import AuthService from '@/services/auth.service'
import UserService from '@/services/user.service'
import ProjectService from '@/services/project.service'
import { userActionTypes } from '../actionTypes'
import router from '@/router/router'
import $utils from '@/utils/utils'

let types = userActionTypes

const state = {
    token: AuthService.getToken(),
    token_refresh: AuthService.getRefreshToken(),
    login_method: AuthService.getLoginMethod(),
    profile: {},
    roles: [],
    wallet: {},
    projects: [],
    currentProject: null,
    currentProjectId: '',
    // check data is loaded
    isProjectsLoaded: false,
    isCurrentProjectIdLoaded: false,
    isProfileLoaded: false
}

const mutations = {
    [types.TOKEN]: (state, token) => {
        state.token = token
        AuthService.setToken(token)
    },
    [types.TOKEN_REFRESH]: (state, token_refresh) => {
        state.token_refresh = token_refresh
        AuthService.setRefreshToken(token_refresh)
    },
    [types.PROFILE]: (state, profile) => {
        state.profile = profile
        state.roles = Array.isArray(profile.roles) ? profile.roles : []
        state.isProfileLoaded = true
    },
    [types.LOGIN_METHOD]: (state, method) => {
        state.login_method = method
        AuthService.setLoginMethod(method)
    },
    [types.PROJECTS]: (state, projects) => {
        state.projects = projects
        state.isProjectsLoaded = true
    },
    [types.CURRENT_PROJECT_ID]: (state, projectId, isNew) => {
        if (isNew) {
            if (this.projects.length > 0) {
                state.currentProjectId = state.projects[0].id
                AuthService.setCurrentProjectId(state.profile.email, state.projects[0].id)
            }
        } else {
            state.currentProjectId = projectId
            AuthService.setCurrentProjectId(state.profile.email, projectId)
        }
        state.isCurrentProjectIdLoaded = true
        if (state.currentProjectId) {
            ProjectService.getProjectById(state.currentProjectId).then(res => {
                state.currentProject = res.data
            }).catch(error => {
                console.log(error)
                state.currentProject = null
                window.vueapp.$appService.toastError(this.$t('projectDoesNotExist'))
            })
        }
    }
}

const actions = {
    [types.GET_PROJECTS] ({ commit }) {
        if (AuthService.getToken()) {
            return new Promise((resolve, reject) => {
                ProjectService.getProjects().then(res => {
                    commit(types.PROJECTS, res.data)
                    resolve()
                }).catch(err => {
                    commit(types.PROJECTS, [])
                    reject(err)
                })
            })
        } else {
            return null
        }
    },
    [types.CURRENT_PROJECT_ID] ({ commit }, projectId) {
        commit(types.CURRENT_PROJECT_ID, projectId)
        return true
    },
    [types.GET_PROFILE] ({ commit }) {
        UserService.getProfile().then(
            result => {
                commit(types.PROFILE, result.data)
                let targetProjectId = window.vueapp.$route.params['project_id']
                if (targetProjectId) {
                    commit(types.CURRENT_PROJECT_ID, targetProjectId, false)
                    return
                }
                let currentProjectId = AuthService.getCurrentProjectId(result.data.email)
                commit(types.CURRENT_PROJECT_ID, currentProjectId, !currentProjectId)
            },
            error => {
                console.log(error)
                window.vueapp.$appService.toastError(this.$t('canNotGetUserProfile'))
            }
        )
    },
    [types.GET_JWT_USER]: ({ commit }, {code, social_type}) => {
        return new Promise((resolve, reject) => {
            UserService.getJwtUser(code, social_type).then(res => {
                commit(types.PROFILE, res.data)
                commit(types.TOKEN, res.data.token)
                commit(types.TOKEN_REFRESH, res.data.refresh)
                commit(types.LOGIN_METHOD, social_type)
                // AuthService.setTokenTimer(res.data.token.refresh, $utils.parseJwt(res.data.token).exp)
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
    [types.RESET_TOKEN] ({ commit }) {
        return new Promise(resolve => {
            AuthService.removeToken()
            commit(types.TOKEN, '')
            commit(types.REFRESH_TOKEN, '')
            commit(types.LOGIN_METHOD, '')
            commit(types.PROFILE, {})
            resolve()
        })
    },
    [types.SIGN_IN] ({ commit }, payload) {
        router.push({ name: 'Login' })
    },
    [types.SIGN_IN_FPTID] ({ commit }, payload) {
        let state = 'fptid'
        let url =
            `${process.env.VUE_APP_AUTHORIZATION_END_POINT}` +
            `?client_id=${process.env.VUE_APP_AUTHORIZATION_CLIENT_ID}` +
            `&redirect_uri=${window.location.origin}/home` +
            `&state=${state}` +
            `&response_type=code` +
            `&scope=openid+profile+email+phone`
        window.location.href = url
    },
    [types.SIGN_IN_GOOGLE] ({ commit }, payload) {
        let state = 'google'
        let url =
            `${process.env.VUE_APP_AUTHORIZATION_END_POINT}` +
            `?client_id=${process.env.VUE_APP_AUTHORIZATION_GOOGLE_CLIENT_ID}` +
            `&redirect_uri=${window.location.origin}/home` +
            `&state=${state}` +
            `&response_type=code` +
            `&scope=openid+profile+email+phone`
        window.location.href = url
    },
    [types.SIGN_IN_FACEBOOK] ({ commit }, payload) {
        let state = 'facebook'
        let url =
            `${process.env.VUE_APP_AUTHORIZATION_END_POINT}` +
            `?client_id=${process.env.VUE_APP_AUTHORIZATION_FACEBOOK_CLIENT_ID}` +
            `&redirect_uri=${window.location.origin}/home` +
            `&state=${state}` +
            `&response_type=code` +
            `&scope=openid+profile+email+phone`
        window.location.href = url
    },
    [types.SIGN_OUT] ({ commit }) {
        AuthService.removeToken().
        finally(() => {
            commit(types.TOKEN, '')
            commit(types.REFRESH_TOKEN, '')
            commit(types.LOGIN_METHOD, '')
            commit(types.PROFILE, {})
            let url = `${process.env.VUE_APP_END_SESSION_END_POINT}?post_logout_redirect_uri=${window.location.origin}/home&client_id=${process.env.VUE_APP_PROFILE_END_POINT_CLIENT_ID}`
            console.log('Logout url:', url)
            window.location.href = url})
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
